import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from '@enginuity/core/molecules/search/search.component';
import { DropdownSinglePieceComponent } from '@enginuity/core/molecules/dropdown-single-piece/dropdown-single-piece.component';
import { Dropdown } from '@services/ui-services/models/dropdown';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  imports: [CommonModule, SearchComponent, DropdownSinglePieceComponent, BadgesComponent],
})
export class DropdownComponent {
  @Input()
  selecteditems: string = '';

  @Output() selectionChanged = new EventEmitter<string>();
  @Output() onClick = new EventEmitter<any>();

  @Input()
  search: boolean = true;

  @Input() dropdownStatus: boolean = false;
  @Input() dropdownList: boolean = true;

  @Output() custom_click = new EventEmitter<string>();

  //TODO: remove any and fix errors
  @Input() dropdown!: Dropdown[] | any;

  @Input() statusDropdown!: Dropdown[] | any;

  onItemSelected(selectedValue: string) {
    this.selecteditems = selectedValue;
    this.selectionChanged.emit(selectedValue);
  }
}
